export default __webpack_public_path__ + "static/media/gtv.b6ce803a.png";